module.exports = __webpack_public_path__ + "static/media/relay.aa7f4967.png";